import { Injectable } from '@angular/core';
import { MyOrganizationFacade, getRolesAndPermission } from '@piqet-angular/data';
import { ColDef } from 'ag-grid-community';
import { right } from '@popperjs/core';
import {
  AccessPermissionService,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';

@Injectable({
  providedIn: 'root',
})
export class SsoGroupDataGridService {
  event: any;
  editSSOGroupData = new Subject<[any, any, any]>();
  SSOGroupObservable$ = this.editSSOGroupData.asObservable();
  deleteSSOGroupData = new Subject<[any, any, any]>();
  SSOGroupDeleteObservable$ = this.deleteSSOGroupData.asObservable();
  manageTeamsPayload: any;
  Access: any;

  constructor(private swalService: SwalService, private accessService: AccessPermissionService) {}

  getSSOGroupDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'GroupId',
      headerName: 'Group',
      field: 'groupId',
      cellClass: 'my-permission-cursor-pointer',
      // sort: 'asc',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'UserRole',
      headerName: 'Role',
      field: 'userRole',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
    });

    this.accessAllPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        cellRendererParams: {
          showEdit: this.isAccess('edit'),
          showDelete: this.isAccess('delete'),
          value: 'ssoGroup',
          editData: (data: any, pathName: any) => {
            this.editSSOGroupData.next([data.id, 'Review SSO group', pathName]);
          },
          deleteData: (data: any, customName: any) => {
            this.deleteSSOGroupConfirmation(
              data.id,
              '/MyOrganizationSSOConfiguration/DeleteMyOrganizationSSOConfiguration?id',
              customName
            );
          },
        },
        lockVisible: true,
        lockPosition: right,
        resizable: false,
      });

    return colDef;
  }

  isAccess = (type: 'view' | 'edit' | 'create' | 'delete') => {
    return this.accessService.hasModulePermission(
      rolesModuleName.myOrganizationSSO,
      mainModuleName.manageOrganizationModule,
      type
    );
  };

  accessAllPermission() {
    const access = this.isAccess('edit') || this.isAccess('delete');
    return access;
  }

  deleteSSOGroupConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteSSOGroupData.next([data, customType, pathName]);
      } else {
      }
    });
  }
}
